module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outlets"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-condition"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('Placeholder.OutletSearch')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchByCondition($event)
      }
    },
    model: {
      value: (_vm.condition.search),
      callback: function($$v) {
        _vm.condition.search = $$v
      },
      expression: "condition.search"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 sm-margin"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('sl-btn', {
    staticClass: "sl-btn-lightblue",
    attrs: {
      "text": _vm.$t('Functional.confirm')
    },
    nativeOn: {
      "click": function($event) {
        _vm.searchByCondition($event)
      }
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "sl-el-btn sl-btn-green",
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Add-New-Outlet'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Link', 'Add new store', 'Stores')
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('Button.addNewOutlet')))])], 1)])])], 1)])]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sl-body"
  }, [_c('row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reloadBtn),
      expression: "reloadBtn"
    }],
    staticClass: "sl-table-reload"
  }, [_vm._v(" " + _vm._s(_vm.$t('Notify.errorMsg')) + "\n          "), _c('sl-btn', {
    staticClass: "sl-btn-lightblue",
    attrs: {
      "text": _vm.$t('Functional.reload')
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadTable($event)
      }
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "200",
      "fixed": _vm.$store.state.userAgent.isPhone ? false : 'left',
      "show-overflow-tooltip": true,
      "prop": "name",
      "label": _vm.$t('Views.Outlets.table.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "address",
      "label": _vm.$t('Views.Outlets.table.address'),
      "formatter": _vm.formatterAddress
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "contact",
      "label": _vm.$t('Views.Outlets.table.contact')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "phone",
      "label": _vm.$t('Views.Outlets.table.phone')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "status",
      "label": "Approval status",
      "formatter": _vm.formatterStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": _vm.$store.state.userAgent.isPhone ? 150 : 200,
      "fixed": "right",
      "label": _vm.$t('Table.actions')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "sl-edit",
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('Table.edit')))]), _vm._v(" "), _c('el-button', {
          staticClass: "sl-detail",
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.gotoPage(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(_vm.$tc('Table.view', 1)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.reloadBtn),
      expression: "!reloadBtn"
    }],
    attrs: {
      "current-page": _vm.table.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.table.per,
      "layout": "prev, pager, next, sizes,jumper,total",
      "total": _vm.table.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-554be451!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/management/outlets/outlets.vue
// module id = 1110
// module chunks = 1